/**
 * GA menu visibility (Training List, Share Knowledge).
 * Requires API flags with group + user AND logic from infoUserV2.
 */
export const canShowTrainingListMenu = (userInfoHeader) =>
    Boolean(userInfoHeader?.isAllowTrainingList);

export const canShowShareKnowledgeMenu = (userInfoHeader) =>
    Boolean(userInfoHeader?.isAllowShareKnowledgeMenu);
